var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('v-flex',{attrs:{"align-self-center":""}},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('v-flex',[_c('article',[_c('img',{staticClass:"img",attrs:{"src":_vm.imageUrl,"alt":""}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }